import { Box, Typography, styled } from '@mui/material';

export const StyledFooter = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(7),
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  '> svg': {
    height: '45px',
    width: '45px',
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  color: theme.palette.primary.main,
}));

export const StyledMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  whiteSpace: 'pre-wrap',
}));
